/**
 * @file useIntegrationTransfer.tsx
 * @description «Перенести в магазин…» на странице «Общие интеграции»
 * (phase19.28 этап А; PL13; runbook — перенос SMTP chaiberi.ru): одно окно
 * выбора магазина на полосу-напоминание и на действие строки любой общей
 * (shopId = null) интеграции.
 *
 * Перенос пишет интеграцию и читает список магазинов — нужны права
 * PLATFORM_MANAGE_INTEGRATIONS и PLATFORM_MANAGE_SHOPS (ревью В3); без них
 * `start` — null, кнопок нет.
 */

import { useState, type ReactNode } from "react";

import { useHasPermission } from "../../../auth/hooks";
import type { PlatformIntegrationDto } from "../../../lib/api-platform-integrations";
import { SHOPS_PERMISSION } from "../../../lib/api-platform-shops";
import { TransferIntegrationDialog } from "./TransferIntegrationDialog";

export interface IntegrationTransferApi {
  /** Открыть окно переноса; null — нет прав. */
  start: ((item: PlatformIntegrationDto) => void) | null;
  dialog: ReactNode;
}

export function useIntegrationTransfer(onTransferred: () => void): IntegrationTransferApi {
  const canIntegrations = useHasPermission("PLATFORM_MANAGE_INTEGRATIONS");
  const canShops = useHasPermission(SHOPS_PERMISSION);
  const [item, setItem] = useState<PlatformIntegrationDto | null>(null);
  const allowed = canIntegrations && canShops;
  return {
    start: allowed ? setItem : null,
    dialog: allowed ? (
      <TransferIntegrationDialog
        item={item}
        onClose={() => setItem(null)}
        onTransferred={() => {
          setItem(null);
          onTransferred();
        }}
      />
    ) : null,
  };
}
